import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '../buttons/buttons.module';
import { CmSearchBoxComponent } from './cm-search-box.component';

@NgModule({
  declarations: [CmSearchBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonsModule,
  ],
  exports: [CmSearchBoxComponent],
})
export class CmSearchBoxModule {}
